module.exports = __webpack_public_path__ + "media/images/suppliers/zytomedsystems-f597c1223e8480b46c3f4ab3ae24f527.png";